// @flow

import React from 'react'
import PT from 'prop-types'
import Icon from '@vimcar/shared-components/components/Icon'
import i18n from '#utils/i18n'
import { type ObservableArray } from 'mobx'

import styles from './styles.css'

const tp = i18n.prefix('components.ShiftmoveIntegrationInfo')

type Props = {
  routeContext?: string,
}

type ExtendedUser = {
  fusionAuthRegistrations?: ObservableArray<string>,
}

const getDeepLinkPath = (routeContext: ?string): string => {
  switch (routeContext) {
    case 'createBooking':
      return '/pool-reservations/new'
    case 'bookings':
      return '/home'
    default:
      return ''
  }
}

const getLocalizedImage = (): string => {
  const currentLanguage = i18n.currentLanguage
  const isGerman = currentLanguage.startsWith('de')
  return isGerman 
    ? '/static/images/avrios-driver-app-de.png'
    : '/static/images/avrios-driver-app-en.png'
}

const ShiftmoveIntegrationInfo = ({ routeContext }: Props, context: any) => {
  const deepLinkPath = getDeepLinkPath(routeContext)
  const imageSource = getLocalizedImage()
  const appUri = global.AVRIOS_DRIVER_APP_URI
  const fullUri = appUri ? `${appUri}${deepLinkPath}` : appUri
  
  const userinfo: ?ExtendedUser = context.users && context.users.self
  const hasAvriosAccess = userinfo && 
    userinfo.fusionAuthRegistrations && 
    userinfo.fusionAuthRegistrations.includes('avrios-driver')

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img 
          alt="Avrios Driver App"
          className={styles.image}
          src={imageSource} 
        />
      </div>
      
      <h1 className={styles.title}>
        {tp(hasAvriosAccess ? 'title' : 'title-no-access')}
      </h1>
      
      <p className={styles.description}>
       {tp(hasAvriosAccess ? 'description' : 'description-no-access')}
      </p>

      {hasAvriosAccess && (
        <button
          className={styles.button}
          onClick={() => {
            window.open(fullUri, '_blank')
          }}
        >
          {tp('open-driver-app')} <Icon icon='arrow-right' />
        </button>
      )}
    </div>
  )
}

ShiftmoveIntegrationInfo.propTypes = {
  routeContext: PT.string,
}

ShiftmoveIntegrationInfo.contextTypes = {
  users: PT.object.isRequired,
}

export default ShiftmoveIntegrationInfo
